
import ApresentacaoInicial from '../../sections/ApresentacaoInicial';
import Portifolio from '../../sections/Portifolio';
import SobreNos from '../../sections/SobreNos';
import './HomePage.css'
function HomePage(){
    return <>
        <ApresentacaoInicial />
        <Portifolio />
        <SobreNos />
    </>
}

export default HomePage